import * as React from 'react'
import { FC } from 'react'

import { EntityCardHeader } from '@user/components/EntityCards/Header'
import { ISalesFunnelCard } from '@user/store/salesFunnelSummary/typings'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const styles = {
  title: {
    fontSize: '18px',
    fontFamily: 'Source Sans Pro Semibold',
  },
}

interface Props {
  funnel: ISalesFunnelCard
}

export const SalesFunnelCardHeader: FC<Props> = (props) => {
  const {
    funnel: { avgTimeToClose, closedWonConversionRate, salesFunnelName },
  } = props

  return (
    <EntityCardHeader>
      <Box display="flex" mb={1}>
        <Box display="flex" flexGrow={1}>
          <Typography sx={styles.title}>
            {salesFunnelName} Sales Funnel
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          <Typography component="div">
            Average Time to Close: <b>{avgTimeToClose} days</b>
          </Typography>
          <Typography component="div">
            Closed/Won Conversion Rate: <b>{closedWonConversionRate}%</b>
          </Typography>
        </Box>
      </Box>
    </EntityCardHeader>
  )
}

SalesFunnelCardHeader.displayName = 'SalesFunnelCardHeader'
